import _classCallCheck from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { uuid4 } from '@sentry/utils';
import { TRACE_FLAG_NONE } from '../utils/spanUtils.js';

/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */
var SentryNonRecordingSpan = /*#__PURE__*/function () {
  function SentryNonRecordingSpan() {
    var spanContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, SentryNonRecordingSpan);
    this._traceId = spanContext.traceId || uuid4();
    this._spanId = spanContext.spanId || uuid4().substring(16);
  }

  /** @inheritdoc */
  _createClass(SentryNonRecordingSpan, [{
    key: "spanContext",
    value: function spanContext() {
      return {
        spanId: this._spanId,
        traceId: this._traceId,
        traceFlags: TRACE_FLAG_NONE
      };
    }

    /** @inheritdoc */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  }, {
    key: "end",
    value: function end(_timestamp) {}

    /** @inheritdoc */
  }, {
    key: "setAttribute",
    value: function setAttribute(_key, _value) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setAttributes",
    value: function setAttributes(_values) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setStatus",
    value: function setStatus(_status) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "updateName",
    value: function updateName(_name) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "isRecording",
    value: function isRecording() {
      return false;
    }

    /** @inheritdoc */
  }, {
    key: "addEvent",
    value: function addEvent(_name, _attributesOrStartTime, _startTime) {
      return this;
    }
  }]);
  return SentryNonRecordingSpan;
}();
export { SentryNonRecordingSpan };